import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from "react";
import { Box, Button, Card, Grid, Icon, Link, Modal, Table, Text } from "~/components-shared";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { truncatedContent } from "~/lib/helpers";
import TopicFootprintSmall from "../TopicFootprintSmall";
import TopicSummaryRevenueCardModal from "../TopicSummaryRevenueCardModal";
const Scrollable = styled.div`
  overflow: auto;
  max-height: 600px;
  width: 100%;
`;
const StyledGrid = styled(Grid)`
  overflow: hidden;
  position: relative;
`;
const TopicSummaryRevenueCard = _ref => {
  let {
    revenue,
    footprints,
    ...rest
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    opportunities
  } = revenue;
  const activityLimit = 5;
  const charLimitName = 20;
  const charLimitStage = 18;
  const largestOpportunities = opportunities.slice(0, activityLimit);
  const [expanded, setExpanded] = useState(false);
  const [displayedOpportunities, setDisplayedOpportunities] = useState(largestOpportunities);
  const [opportunityData, setOpportunityData] = useState(undefined);
  const handleExpanded = () => {
    if (!expanded) {
      setDisplayedOpportunities(opportunities);
    } else {
      setDisplayedOpportunities(largestOpportunities);
    }
    setExpanded(!expanded);
  };
  function handleOpenModal(opportunity) {
    setOpportunityData(opportunity);
  }
  return /*#__PURE__*/React.createElement(Card, _extends({
    s: {
      p: 0
    },
    fullWidth: true
  }, rest), /*#__PURE__*/React.createElement(Box, {
    s: {
      mx: -1
    }
  }, /*#__PURE__*/React.createElement(Table, {
    size: "s"
  }, /*#__PURE__*/React.createElement(Table.Header, null, /*#__PURE__*/React.createElement(Table.Tr, null, /*#__PURE__*/React.createElement(Table.Th, {
    width: "45%"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 3
  }, "Opportunity")), /*#__PURE__*/React.createElement(Table.Th, {
    width: "18%"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 3
  }, "Amount")), /*#__PURE__*/React.createElement(Table.Th, {
    width: "42%"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 3
  }, "Stage")))), /*#__PURE__*/React.createElement(Table.Body, null, displayedOpportunities.map(opportunity => /*#__PURE__*/React.createElement(Table.Tr, {
    key: opportunity.id
  }, /*#__PURE__*/React.createElement(Table.Td, {
    noHover: true
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold"
  }, opportunity?.name?.length > charLimitName ? /*#__PURE__*/React.createElement(Link, {
    color: "text",
    onClick: () => handleOpenModal(opportunity),
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-html": `<div>${opportunity?.name}</div>`
  }, truncatedContent(opportunity?.name, charLimitName)) : /*#__PURE__*/React.createElement(Link, {
    color: "text",
    onClick: () => handleOpenModal(opportunity)
  }, truncatedContent(opportunity?.name, charLimitName)))), /*#__PURE__*/React.createElement(Table.Td, {
    noHover: true
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold"
  }, opportunity?.amount > 0 ? `${opportunity?.currency}${opportunity?.amount?.toLocaleString("en-US")}` : "-")), /*#__PURE__*/React.createElement(Table.Td, {
    noHover: true
  }, opportunity?.stage?.length > charLimitStage ? /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold",
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-html": `<div>${opportunity?.stage}</div>`
  }, truncatedContent(opportunity?.stage, charLimitStage)) : /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold"
  }, truncatedContent(opportunity?.stage, charLimitStage))), /*#__PURE__*/React.createElement(Table.Td, {
    noHover: true
  }, /*#__PURE__*/React.createElement(Button, {
    color: "translucent",
    onClick: () => handleOpenModal(opportunity),
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-html": "View details",
    rounded: true,
    s: {
      px: 1.5,
      py: 1,
      mt: -1
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "arrow"
  })))))))), opportunities?.length > activityLimit && /*#__PURE__*/React.createElement(Button, {
    onClick: e => {
      e.stopPropagation();
      handleExpanded();
    },
    color: "translucent",
    display: "block",
    fontSize: 3.5,
    s: {
      py: 2,
      px: 4,
      mt: 3
    },
    outline: false,
    textAlign: "center",
    fullWidth: true
  }, expanded ? t("TopicSummaryRevenueCard.showLess") : t("TopicSummaryRevenueCard.showAll", {
    count: opportunities.length - activityLimit
  })), /*#__PURE__*/React.createElement(Text, {
    fontSize: 5,
    weight: "semiBold",
    s: {
      mt: 8,
      pb: 2
    }
  }, t("TopicSummaryRevenueCard.recentActivity")), /*#__PURE__*/React.createElement(Scrollable, null, /*#__PURE__*/React.createElement(StyledGrid, {
    cols: 1,
    template: "1fr",
    gap: 3,
    fullWidth: true,
    s: {
      ml: -2,
      mt: 2,
      pt: 2
    }
  }, footprints.map(footprint => /*#__PURE__*/React.createElement(TopicFootprintSmall, {
    key: footprint.id,
    footprint: footprint
  })))), /*#__PURE__*/React.createElement(Modal, {
    open: !!opportunityData
  }, /*#__PURE__*/React.createElement(TopicSummaryRevenueCardModal, {
    opportunity: opportunityData,
    onClose: () => setOpportunityData(undefined)
  })));
};
export default TopicSummaryRevenueCard;